import SelfServiceEntityTable from "./SelfServiceEntityTable";

export default SelfServiceEntityTable;
